.main {
  display: contents;
}
